var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 7h9m-9 4h5m-5 4h3m8.59.27H20v-1.41m-4.58 4.47h-1.41v1.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17.87c-.15.45-.4.86-.73 1.2a3.2 3.2 0 01-5.08-.73m5.63-3.07a3.2 3.2 0 00-5.08-.73 3.1 3.1 0 00-.74 1.2"
  }))));
}
export default SvgSwitchList;